/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 删除商品订单
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  orderId: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "delete",
    url: `/order/good-order/${orderId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
